import React,  { useState, useEffect, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import Form from 'react-bootstrap/Form';
import { useForm } from "react-hook-form";
import IntlTelInput from "intl-tel-input/reactWithUtils";
import {sanitizePhoneNumber } from "../../utils/utilsHelpers";


function InputPhoneNumber(props) {

    const { register, handleSubmit, clearErrors, setValue, setError, formState: { errors, isValid, isSubmitting }} = useForm();
    const [cta, setCta] = useState('Send verification code');
    const [isPhoneValid, setIsPhoneValid] = useState(false);
    const [phone, setPhone] = useState(props.currentUser?.phone);
    const [errorMessage, setErrorMessage] = useState(props.twilioError);
    const [twilioAttempts, setTwilioAttempts] = useState(0);
    const [allowSkip, setAllowSkip] = useState(false);
    const isPhoneValidRef = useRef(isPhoneValid);

    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    }

    useEffect(() => {
        register('user.phone', {
            pattern: { value: /^([^a-zA-z]*)$/g, message: 'This phone number pattern is invalid' },
            validate: () => isPhoneValidRef.current || `This phone number new is invalid ${phone}` });

        if(phone) {
            setValue('user.phone', phone);
        }
    }, [register]);

    useEffect(() => {
        setValue('user.phone', phone)
        clearErrors('user.phone');
    }, [phone]);

    useEffect(() => {
        isPhoneValidRef.current = isPhoneValid;
    }, [isPhoneValid]);

    // Render functions

    const renderSubheader = () => {
        if(!props.showPhone || props.emailOnly) {
            return (
                <>
                    To verify your identity, please enter your phone number and we will send you a verification code.
                </>
            )
        }  else if(props.isLandline) {
            return (
                <>
                    You will receive a call to verify your number. If you prefer to verify by SMS please provide a mobile number.
                </>
            )
        } else {
            return (
                <>
                    We're about to send you a verification code, please make sure we have your correct phone number.
                </>
            )
        }
    }

    const renderErrorMessage = () => {
        if(errorMessage) {
            return (
                <div className={'mt-4 bg-soft-danger border border-danger text-danger fw-bold rounded p-2'} style={{ fontSize: '12px'}}>
                    {errorMessage}
                </div>
            )
        }
    }

    const renderSkipButton = () => {
        if(allowSkip) {
            return (
                <div className={'text-end mt-3'}>
                    <div className={'btn btn-link text-secondary p-0 fw-normal'} onClick={() => onSkipHandler()}>
                        Skip
                    </div>
                </div>
            )
        }
    }

    // Event handlers

    const onSendCode = async(data) => {
        setCta('Sending...');
        let userPhone = sanitizePhoneNumber(data.user.phone);
        let sendData = { id: props.currentUser?.id, phone: userPhone, authenticity_token: props.token}

        if(userPhone !== phone) {
            setTwilioAttempts(1);
            setPhone(userPhone);
            setAllowSkip(false);
        } else setTwilioAttempts(twilioAttempts + 1);

        await fetch('/users/send_verification_code', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(sendData)
        }).then(function(response) {
            return response.json();
        }).then(function(jsonResponse) {
            if(jsonResponse.skip_verification === true) {
                props.onNextModal({ skip: 2, user: { phone: userPhone }, redirect_path: jsonResponse?.redirect_path}); // proceed with flow
            } else if(jsonResponse.success === true) {
                props.updateLandline(!!jsonResponse?.landline);
                props.onNextModal({ user: { phone: userPhone }, redirect_path: jsonResponse?.redirect_path});
            }  else {
                setCta('Send verification code');
                setErrorMessage(jsonResponse?.error);
                setAllowSkip(twilioAttempts >= 2);
                // props.onNextModal({ skip: 2, user: { phone: userPhone }}); //
            }
        });
    }

    const onSkipHandler = () => {
        props.onNextModal({ skip: 2 });
    }

    return (
        <>
            <Modal.Header className={'border-bottom-0 pt-4 pb-0 justify-content-center text-center'}>
                <Modal.Title className={'fs-4 mb-0'}>
                    {props.emailOnly ? 'Fill in a phone number' : 'Verify your phone number'}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className={'text-secondary px-2 px-sm-4 mx-1 pt-0'}>
                <div className={'mb-4 secondary-links fs-6 text-center'}>
                    {renderSubheader()}
                </div>

                <Form noValidate={true} onSubmit={handleSubmit(onSendCode)}>
                    <Form.Group className="mb-2">
                        <IntlTelInput
                            inputProps={{
                                className: 'form-control form-control-lg text-secondary'
                            }}
                            initialValue={phone || '+1'}
                            onChangeNumber={setPhone}
                            onChangeValidity={setIsPhoneValid}
                            initOptions={{
                                containerClassName: 'd-block',
                                nationalMode: false,
                            }}
                        />
                        {errors.user?.phone && <Form.Text className="text-danger">{errors.user.phone.message}</Form.Text>}
                    </Form.Group>
                    <Button variant="primary" type="submit" className={'btn-block btn-hover-cursor mt-4'} disabled={isSubmitting}>
                        {cta}
                    </Button>
                </Form>
                {renderErrorMessage()}
                {renderSkipButton()}
            </Modal.Body>
        </>
    )
}

InputPhoneNumber.displayName = 'InputPhoneNumber';

export default InputPhoneNumber;